import axios from 'axios'





// create an axios instance
const service = axios.create({
  //baseURL: 'http://localhost:8044/', // url = base url + request url
  baseURL: '/api',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

service.interceptors.request.use((config) => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  return config
})


export default service
